//
// EsriWebMapProvider.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../../moduleBuilder";
import EventDispatcher from "../../../events/EventDispatcher";
import "../../../lib";
import "./MapLayerProvider";

var EsriWebMapProvider = createModule("commons::EsriWebMapProvider", ["commons::PropertyOwner","commons::BaseModel","commons::AbstractMapProvider","commons::MapLayerProvider"], EventDispatcher, [
    ,
    {
        apiKey: 7,
        portalItemId: 7,
        basemap: 7,
        URL: 7,
        token: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default EsriWebMapProvider;
